import api from './index.js'

export default {

  getGroups() {
    return api.get('groups.json');
  },

  getGroup(id) {
    return api.get(`groups/${id}.json`);
  },

  createGroup(params) {
    return api.post('groups.json', params);
  },

  deleteGroup(id) {
    return api.delete(`groups/${id}.json`);
  },

  updateGroup(payload) {
    return api.patch(`groups/${payload.groupId}.json`, payload.params);
  }
}
